import { render, staticRenderFns } from "./PageUser.vue?vue&type=template&id=a8d04888&scoped=true&"
import script from "../../../js/views/user/PageUser.js?vue&type=script&lang=js&"
export * from "../../../js/views/user/PageUser.js?vue&type=script&lang=js&"
import style0 from "./PageUser.vue?vue&type=style&index=0&id=a8d04888&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8d04888",
  null
  
)

export default component.exports